import { Form } from "react-router-dom";

export default function Detail() {
  const detail = {
    first: "Your",
    last: "Name",
    avatar: "https://robohash.org/you.png?size=200x200",
    twitter: "your_handle",
    notes: "Some notes",
    favorite: true,
  };

  return (
    <div id="detail">
      <div>
        <img
          key={detail.avatar}
          src={
            detail.avatar ||
            `https://robohash.org/${detail.id}.png?size=200x200`
          }
        />
      </div>

      <div>
        <h1>
          {detail.first || detail.last ? (
            <>
              {detail.first} {detail.last}
            </>
          ) : (
            <i>No Name</i>
          )}{" "}
          <Favorite detail={detail} />
        </h1>

        {detail.twitter && (
          <p>
            <a
              target="_blank"
              href={`https://twitter.com/${detail.twitter}`}
            >
              {detail.twitter}
            </a>
          </p>
        )}

        {detail.notes && <p>{detail.notes}</p>}

        <div>
          <Form action="edit">
            <button type="submit">Edit</button>
          </Form>
          <Form
            method="post"
            action="destroy"
            onSubmit={(event) => {
              if (
                !window.confirm(
                  "Please confirm you want to delete this record."
                )
              ) {
                event.preventDefault();
              }
            }}
          >
            <button type="submit">Delete</button>
          </Form>
        </div>
      </div>
    </div>
  );
}

function Favorite({ detail }) {
  const favorite = detail.favorite;
  return (
    <Form method="post">
      <button
        name="favorite"
        value={favorite ? "false" : "true"}
        aria-label={
          favorite
            ? "Remove from favorites"
            : "Add to favorites"
        }
      >
        {favorite ? "★" : "☆"}
      </button>
    </Form>
  );
}